import fetch from '@/utils/fetch';

const model = {
  state: {
    // 小程序店铺状态
    weAppShopStatus: {},
    // 小程序授权
    weAppAuthData: {},
    weAppAuthUrl: null,
    // 公众号授权
    wePubAuthData: {},
    wePubAuthUrl: null,
    agentModalVisible: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { welcome }, getState }) => ({
    setAgentVisible(value) {
      welcome.setState({ agentModalVisible: value });
    },
    // 获取丰食小程序授权数据
    async getWeAppAuthData() {
      const data = await fetch('/saasmerchant/web/fengshi/wx/info');
      if (data) {
        welcome.setState({ weAppAuthData: data });
      }
    },
  }),
};

export default model;
